import { useState } from "react";
import { MdClose, MdSave, MdDelete, MdInfo, MdCloudUpload } from "react-icons/md";
import "./NewRepairOrder.scss";

interface NewRepairOrderProps {
  onClose: () => void;
}

export default function NewRepairOrder({ onClose }: NewRepairOrderProps) {
  const [imei, setImei] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [loanDevice, setLoanDevice] = useState("");
  const [loanDeviceManual, setLoanDeviceManual] = useState("");

  return (
    <div className="new-repair-order-overlay" onClick={onClose}>
      <div className="new-repair-order-modal" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          className="new-repair-order-modal__close"
          onClick={onClose}
          aria-label="Modal schließen"
        >
          <MdClose />
        </button>

        <header className="new-repair-order-modal__header">
          <h2>Neuen Reparaturauftrag anlegen</h2>
          <p>Erfassen Sie die Daten zum Auftrag. Pflichtfelder sind mit * markiert.</p>
        </header>

        <div className="new-repair-order-modal__content">
          <section className="new-repair-order-modal__section">
            <h3 className="new-repair-order-modal__section-title">
              <MdSave /> Daten zum Auftrag
            </h3>

            <div className="new-repair-order-modal__field">
              <label htmlFor="device">Gerät</label>
              <input id="device" type="text" placeholder="z. B. iPhone 15 Pro" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="manufacturer">Hersteller</label>
              <input id="manufacturer" type="text" placeholder="z. B. Apple" />
            </div>

            <div className="new-repair-order-modal__field-row">
              <div className="new-repair-order-modal__field">
                <label htmlFor="imei">IMEI*</label>
                <input
                  id="imei"
                  type="text"
                  placeholder="15-stellige IMEI"
                  value={imei}
                  onChange={(event) => setImei(event.target.value)}
                />
              </div>
              <span className="new-repair-order-modal__or">oder</span>
              <div className="new-repair-order-modal__field">
                <label htmlFor="serial">Seriennummer*</label>
                <input
                  id="serial"
                  type="text"
                  placeholder="Seriennummer"
                  value={serialNumber}
                  onChange={(event) => setSerialNumber(event.target.value)}
                />
              </div>
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="processing">Abwicklung (Versicherung / Garantie)</label>
              <select id="processing" defaultValue="">
                <option value="" disabled>
                  Bitte wählen
                </option>
                <option value="versicherung">Versicherung</option>
                <option value="garantie">Garantie</option>
                <option value="kostenpflichtig">Kostenpflichtig</option>
              </select>
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="accessories">sonstiges Zubehör</label>
              <input id="accessories" type="text" placeholder="z. B. Ladekabel, Hülle" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="lockCode">Sperrcode</label>
              <input id="lockCode" type="text" placeholder="Sperrcode des Geräts" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="condition">Gerätezustand</label>
              <select id="condition" defaultValue="">
                <option value="" disabled>
                  Bitte wählen
                </option>
                <option value="neu">Neuwertig</option>
                <option value="gut">Gut</option>
                <option value="gebraucht">Gebrauchsspuren</option>
                <option value="defekt">Defekt</option>
              </select>
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="conditionNote">Zustand Ergänzung</label>
              <input id="conditionNote" type="text" placeholder="Ergänzende Beschreibung" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="backup">Datensicherung durchführen</label>
              <select id="backup" defaultValue="">
                <option value="" disabled>
                  Bitte wählen
                </option>
                <option value="ja">Ja</option>
                <option value="nein">Nein</option>
                <option value="kunde">Kunde sichert selbst</option>
              </select>
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="maxCost">maximale Reparaturkosten</label>
              <input id="maxCost" type="text" placeholder="0,00 €" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="totalAmount">Endbetrag</label>
              <input id="totalAmount" type="text" placeholder="0,00 €" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="deposit">Anzahlung</label>
              <input id="deposit" type="text" placeholder="0,00 €" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="kvFlat">KV Pauschale</label>
              <input id="kvFlat" type="text" placeholder="0,00 €" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="pickupDate">Abholdatum</label>
              <input id="pickupDate" type="date" />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="errorDescription">Fehlerbeschreibung</label>
              <select id="errorDescription" defaultValue="">
                <option value="" disabled>
                  Bitte wählen
                </option>
                <option value="display">Display defekt</option>
                <option value="akku">Akku schwach</option>
                <option value="wasser">Wasserschaden</option>
                <option value="sonstiges">Sonstiges</option>
              </select>
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="errorDescriptionNote">Fehlerbeschreibung ergänzend</label>
              <textarea id="errorDescriptionNote" placeholder="Detaillierte Fehlerbeschreibung..." />
            </div>

            <div className="new-repair-order-modal__field-row new-repair-order-modal__field-row--loan">
              <label className="new-repair-order-modal__loan-label">Leihgerät:</label>
              <select
                className="new-repair-order-modal__loan-select"
                value={loanDevice}
                onChange={(event) => setLoanDevice(event.target.value)}
              >
                <option value="">Aus Leihgeräteliste wählen</option>
                <option value="iphone-13">iPhone 13</option>
                <option value="samsung-s22">Samsung Galaxy S22</option>
                <option value="ipad">iPad Air</option>
              </select>
              <button
                type="button"
                className="new-repair-order-modal__icon-btn"
                aria-label="Leihgerät löschen"
                title="Leihgerät löschen"
              >
                <MdDelete />
              </button>
              <button
                type="button"
                className="new-repair-order-modal__icon-btn"
                aria-label="Info"
                title="Info"
              >
                <MdInfo />
              </button>
              <span className="new-repair-order-modal__or">oder</span>
              <input
                className="new-repair-order-modal__loan-input"
                type="text"
                placeholder="Leihgerät eintragen"
                value={loanDeviceManual}
                onChange={(event) => setLoanDeviceManual(event.target.value)}
              />
            </div>

            <div className="new-repair-order-modal__field">
              <label htmlFor="internalNote">interne Notiz</label>
              <textarea id="internalNote" placeholder="Interne Notizen zum Auftrag..." />
            </div>

            <div className="new-repair-order-modal__attachments">
              <label className="new-repair-order-modal__attachments-label">
                Anhänge (Bilder & Dokumente):
              </label>
              <div className="new-repair-order-modal__dropzone">
                <MdCloudUpload className="new-repair-order-modal__dropzone-icon" />
                <p>Dateien hier ablegen oder klicken, um Bilder/Dokumente auszuwählen</p>
              </div>
            </div>
          </section>
        </div>

        <footer className="new-repair-order-modal__footer">
          <button
            type="button"
            className="new-repair-order-modal__btn new-repair-order-modal__btn--reset"
            onClick={() => {
              setImei("");
              setSerialNumber("");
              setLoanDevice("");
              setLoanDeviceManual("");
            }}
          >
            Alles zurücksetzen
          </button>
          <button
            type="button"
            className="new-repair-order-modal__btn new-repair-order-modal__btn--submit"
          >
            Reparaturauftrag erstellen
          </button>
        </footer>
      </div>
    </div>
  );
}
